import { BfxBlotterOrdersContextMenuItemCancelState } from "./BfxBlotterOrdersContextMenuItemCancelState";

import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterOrdersContextMenuItemTakeState } from "./BfxBlotterOrdersContextMenuItemTakeState";

export class BfxBlotterOrdersContextMenuForceTakeItem extends BfxBlotterOrdersContextMenuItem {
  constructor(public forceTake: boolean = false) {
    super(
      BfxBlotterAction.ACTION_FORCE_TAKE,
      "Force Take",
      BfxBlotterOrdersContextMenuForceTakeItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuForceTakeItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.MenuItem,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BfxBlotterOrdersContextMenuItemTakeState();
    this.state.title = oldState.title;
  }

  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
    ) {
      itemState.available = menuState.canForceSteal;
    };
  }

  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemTakeState,
      item: CubiqTS.OrderDataImpl,
    ) {
      if (!item) {
        itemState.enabled = false;
      } else {
        itemState.enabled =
          itemState.enabled &&
          BfxBlotterOrdersContextMenuForceTakeItem.checkOwnership(item, menuState);
        itemState.enabled =
          itemState.enabled &&
          BfxBlotterOrdersContextMenuForceTakeItem.checkOrderState(item, menuState);
      }

      itemState.count++;
    };
  }

  private static checkOwnership(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): boolean {
    let enabled: boolean = false;

    if (item.deskId != null && menuState.traderGroups.has(item.deskId.toString())) {
      enabled = menuState.traderGroups.get(item.deskId.toString()).isExternallyFilledFg;
    }

    return enabled;
  }

  private static checkOrderState(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): boolean {
    let enabled: boolean = false;

    switch (item.orderState) {
      case CubiqTS.OrderState.ACTIVE:
      case CubiqTS.OrderState.PENDING:
      case CubiqTS.OrderState.SUSPENDED:
      case CubiqTS.OrderState.TRIGGERED:
      case CubiqTS.OrderState.PENDING_CANCELLATION:
        enabled = true;
        break;
      default:
        enabled = false;
        break;
    }

    return (
      enabled &&
      (item.lockUserId == null ||
        item.lockUserId.toString() == menuState.activeUser.userId.toString())
    );
  }

  public static get state(): any {
    return new BfxBlotterOrdersContextMenuItemTakeState();
  }
}
